// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/impact/impact.component.css
// module id = 752
// module chunks = 0